import React, { FC, useEffect, useState } from 'react'
import styles from './TwoColumnModal.module.scss'
import Modal from '../../../components/Modals/Modal/Modal'

interface Props {
  modalHeader: string
  onClose: () => void
  defaultOpen: boolean
  children?: React.ReactNode
}
export const TwoColumModal: FC<Props> = ({
  modalHeader,
  onClose,
  defaultOpen,
  children
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen)
  const handleClose = () => {
    setIsOpen(false)
    onClose()
  }
  useEffect(() => {
    setIsOpen(defaultOpen)
  }, [defaultOpen])

  return (
    <Modal isOpen={isOpen} handleClose={handleClose} mobileHasFullHeight>
      <div className={styles.FormModalContainer}>
        <div className={styles.InsideContainer}>
          <div
            data-testid="two-col-form-modal-header-container"
            className={styles.ModalHeader}
          >
            {modalHeader}
          </div>
          {children}
        </div>
      </div>
    </Modal>
  )
}
